import { AppState } from 'store';
import { IProgramSummaryState } from './types';

export const programSummarySelector = ({ programSummaryState }: AppState): IProgramSummaryState => programSummaryState;
